import ModuleButton from './ModuleButton.vue';

export default ModuleButton;



// WEBPACK FOOTER //
// ./src/components/parts/modules/modulebutton/index.ts